import { ThemeConfig } from 'antd';

const theme: ThemeConfig = {
  token: {
    colorPrimary: '#00a241',
    colorPrimaryHover: '#008f39',
    colorPrimaryActive: '#007d32',
    colorSuccess: '#00a241',
    colorError: '#d64d4d',
    colorWarning: '#e97e13',
    colorInfo: '#00a1df',
    colorLink: '#00a241',
    colorText: 'rgba(0, 0, 0, 0.85)',
    borderRadius: 2,
    fontFamily: 'Rubik',
    fontSize: 12,
    lineHeight: 1.5715,
  },
  components: {
    Button: {
      defaultShadow: 'none',
      primaryShadow: 'none',
      dangerShadow: 'none',
      defaultHoverBg: '#f5f5f5',
      defaultHoverColor: '#444444',
      defaultHoverBorderColor: '#bfbfbf',
      defaultActiveBg: '#ebebeb',
      defaultActiveColor: '#303030',
      defaultActiveBorderColor: '#a6a6a6',
    },
    Typography: {
      titleMarginBottom: '0px',
      titleMarginTop: '0px',
    },
    Layout: {
      headerBg: '#f0f0f0',
      siderBg: '#f0f0f0',
      triggerBg: '#f5f6fb',
      triggerColor: '#00a241',
      triggerHeight: 40,
    },
    Menu: {
      radiusItem: 0,
      itemMarginInline: 0,
    },
    Modal: {
      contentPadding: 8,
      headerPadding: 0,
      bodyPadding: 0,
      footerPadding: 0,
      confirmBodyPadding: 0,
    },
    Switch: {
      trackHeight: 22,
      trackMinWidth: 44,
      handleSize: 18,
    },
  },
};

export default theme;
